import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faBookOpen } from '@fortawesome/pro-solid-svg-icons';
import '../assignments.scss';
import PropTypes from 'prop-types';
import appConfig from '../../../app-config';
import { selectCurrentToken } from '../../../features/authentication/authSlice';
import { useSelector } from 'react-redux';
import CustomToast from '../../../components/Toast';
import AttachResources from './questionDetailComponents/AttachResources';
import { useGetHtmlContentMutation } from '../../../features/authentication/assignmentApislice';
import QuestionPreviewTypes from '../../../enums/questionPreviewTypes';
import Skeleton from 'react-loading-skeleton';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { useSetQuestionPointMutation } from '../../../features/authentication/questionApiSlice';
import SkeletonGrid from '../../../components/SkeletonLoader/SkeletonGrid';

const QuestionDetail = (props) => {
  const [hintDetails, setHintDetails] = useState(false);
  const [answerDetails, setAnswerDetails] = useState(false);
  const [reasonDetail, setReasonDetail] = useState(false);
  const [sampleAnswerDetails, setSampleAnswerDetails] = useState(false);
  const [optionDetails, setOptionDetails] = useState(false);
  const formCheckRef = useRef(null);
  const [readingPassage, setReadingPassage] = useState(false);
  const [type1, setType1] = useState(true);
  const [type2, setType2] = useState(true);
  const [tagAttributeStandard, setTagAttributeStandard] = useState(false);
  const [showAnswer, setShowAnswer] = useState(false);
  const baseUrl = appConfig.apiBaseUrl;
  const accessToken = useSelector(selectCurrentToken);
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);
  const [htmlContent, setHtmlContent] = useState(null);
  const [isPassageLoading, setIsPassageLoading] = useState(true);
  const [updatedMaxPoint, setUpdatedMaxPoint] = useState(null);
  const [maxPointUpdateMessage, setMaxPointUpdateMessage] = useState('');
  const [updatedMaxPointError, setUpdatedMaxPointError]= useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  
  const [bookletContainer, setBookletContainer] = useState(null);
  const [bookletNumPages, setBookletNumPages] = useState(0);
  const [bookletCurrentPage, setBookletCurrentPage] = useState(0);
  const bookletCurrentPageRef = useRef(bookletCurrentPage);
  const bookletNumPagesRef = useRef(bookletNumPages);
  const bookletContainerRef = useRef(bookletContainer);
  const [bookletStartClicked, setBookletStartClicked] = useState(false);
  const [documentHtml, setDocumentHtml] = useState('');
  const [bookletCoverUrl, setBookletCoverUrl] = useState('');
  const [isBooklet, setIsBooklet] = useState(false);
  
  const [getHtmlContent] = useGetHtmlContentMutation();
  const [setQuestionPoint] = useSetQuestionPointMutation();

  useEffect(() => {
    let answerLabel = document.querySelectorAll('.answer-label');
    answerLabel.forEach((label) => {
      let paragraphs = label.querySelectorAll('p');
      paragraphs.forEach((paragraph) => {
        let parent = paragraph.parentNode;
        while (paragraph.firstChild) {
          parent.insertBefore(paragraph.firstChild, paragraph);
        }
        parent.removeChild(paragraph);
      });
    });
  }, [answerDetails]);

  useEffect(() => {
    if (props.isLoading == true) {
      setType2(true);
      setType1(true);
    }
    else {
      props.questionDetails?.type === 'MC' || props.questionDetails?.type === 'FillIn'
        ? setType1(true)
        : setType1(false);
      props.questionDetails?.type === 'CR' ? setType2(true) : setType2(false);
    }
    setReadingPassage(false);
  }, [props.isLoading]);

  useEffect(() => {
    if (readingPassage == true) {
      const htmResources = props.questionDetails.question.resources?.filter((resource) =>
        resource.endsWith('.htm')
      );
      htmlContentHandler(htmResources);
    }
  }, [readingPassage]);

  const handlePrint = async () => {
    setIsPdfGenerating(true);
    const contentWrapper = document.getElementById('content');
    const contentClone = contentWrapper.cloneNode(true);

    const header1 = document.createElement('header');
    header1.textContent = 'Question Details';
    header1.style.fontWeight = 'bold';
    header1.style.fontSize = '16px';

    const header2 = document.createElement('header');
    header2.textContent = 'Question';
    header2.style.marginBottom = '10px';

    contentClone.insertBefore(header2, contentClone.firstChild);
    contentClone.insertBefore(header1, contentClone.firstChild);
    const button = contentClone.querySelector('#printButton');
    if (button !== null)
      button.style.display = 'none';

    const divs = contentClone.querySelectorAll('div.toggleDive');
    divs.forEach((div) => {
      if (div.classList.contains('d-none')) {
        div.classList.remove('d-none');
      }
    });

    const buttonRoundedCircle = contentClone.querySelectorAll('button.rounded-circle');
    buttonRoundedCircle.forEach((div) => {
      div.classList.add('d-none');
    });

    const svgElements = contentClone.querySelectorAll('svg');

    svgElements.forEach((svgElement) => {
      if (svgElement.classList.contains('fa-circle-question')) {
        svgElement.classList.add('d-none');
      }
    });

    const base64Encoded = btoa(unescape(encodeURIComponent(contentClone.innerHTML)));

    fetch(`${baseUrl}/PdfGenerator`, {
      method: 'POST',
      body: JSON.stringify({
        htmlContent: base64Encoded,
        OutputFileName: 'QuestionPreview'
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    })
      .then((response) => response.blob())
      .then((blob) => {
        if (blob.type === 'application/pdf') {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          const fileName = 'QuestionPreview.pdf';
          link.download = fileName;
          link.href = url;
          link.click();
          URL.revokeObjectURL(url);
        } else {
          CustomToast('Error ocuurred while generating pdf.', 'error');
        }
        setIsPdfGenerating(false);
      })
      .catch((error) => {
        console.error(error);
        setIsPdfGenerating(false);
      });
  };

  function removePTags(inputString) {
    return inputString.replace(/^<p>|<\/p>$/g, '');
  }

  const htmlContentHandler = async (resourceList) => {
    setHtmlContent([]);
    const htmlContentArray = [];
    resetBookletStateValues();
    setIsPassageLoading(true);
    for (const element of resourceList) {
      const options = { filePath: element };
      const result = await getHtmlContent(options);
      if(result.error)
        htmlContentArray.push(result.error.data.error);
      else
      {
        if(result.data.isBooklet)
        {
          setIsBooklet(true);
          setBookletCoverUrl(result.data.bookletCoverUrl);
          setDocumentHtml(result.data.content);
        }
        else{
          htmlContentArray.push(result.data.content);
        }
      }
    }
    setHtmlContent(htmlContentArray);
    setIsPassageLoading(false);
  };

  const handleUpdateMaxPoint = async (maxPoint)=>{
    if(!maxPoint || maxPoint <= 0 || maxPoint > 100 || isSaving)
      return;
    setUpdatedMaxPointError('');
    setMaxPointUpdateMessage('Saving...');
    setIsSaving(true);
    const options= {
      questionId: props.questionDetails?.questionId,
      assignmentId: props.assignmentId,
      maxPoint: maxPoint
    };

    var response = await setQuestionPoint(options);
    setIsSaving(false);
    if (response?.error) {
      setMaxPointUpdateMessage('');
      if(response.error.data?.errors)
        CustomToast(response.error.data.errors.maxPoint[0], 'error');
      else
        CustomToast(response.error.data.error, 'error');
      return;
    }
    setMaxPointUpdateMessage('Value updated successfully');

    setTimeout(() => {
      setMaxPointUpdateMessage('');
    }, 3000);
  };

  const handleUpdateMaxPointChange = (e) => {
    const value = e.target.value;
    setUpdatedMaxPoint(value);

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    const newTimeout = setTimeout(() => {
      if (value >= 1 && value <= 100) {
        setUpdatedMaxPointError('');
        handleUpdateMaxPoint(value);
      } else {
        setUpdatedMaxPointError('Please enter a number between 1 and 100.');
      }
    }, 500);

    setDebounceTimeout(newTimeout);
  };

  const handleUpdateMaxPointBlur = ()=>{
    if(!updatedMaxPoint || updatedMaxPoint == 0)
    {
      setUpdatedMaxPointError('Please enter a number between 1 and 100.');
    }
  };

  const showBookletPage = (nPrevOrNext) => {
    let nNewPage;
    let numPages = bookletNumPagesRef.current;
    let currentPage = bookletCurrentPageRef.current;
    let container = bookletContainerRef.current;

    if (nPrevOrNext == 1) {
      setBookletStartClicked(true);
      container = document.querySelector('table.booklet').closest('div');
      setBookletContainer(container);

      numPages = container.querySelector('#booklet_numpages').value;
      setBookletNumPages(numPages);
    }

    switch (nPrevOrNext) {
    case 0:
      var a = container.querySelector('#header');
      if (a) {
        a.style.display = 'none';
      }
      nNewPage = 0;
      break;
    case 1:
      setBookletButtons();
      container.querySelector('#header').style.display = 'block';
      nNewPage = 1;
      currentPage = 0;
      break;
    case -1:
      nNewPage = currentPage == 1 ? numPages : currentPage - 1;
      break;
    case -2:
      nNewPage = currentPage == numPages ? 1 : currentPage + 1;
      break;
    default:
      return;
    }
    setBookletCurrentPage(nNewPage);

    const currentPageElement = container.querySelector(`#page${currentPage}`);
    const newPageElement = container.querySelector(`#page${nNewPage}`);

    currentPageElement.classList.add('rs_skip');
    currentPageElement.style.display = 'none';
    newPageElement.classList.remove('rs_skip');
    newPageElement.style.display = 'block';

    container.dataset.currPage = nNewPage;

    const btnPrev = container.querySelector('#btnprev');
    const btnNext = container.querySelector('#btnnext');
    const btnHome = container.querySelector('#btnhome');

    if (nNewPage == numPages) {
      btnPrev.style.display = 'inline';
      btnNext.style.display = 'none';
      btnHome.style.display = 'none';
    } else {
      btnPrev.style.display = 'inline';
      btnNext.style.display = 'inline';
      btnHome.style.display = 'none';
    }
  };

  const setBookletButtons = () => {
    const container = document.querySelector('table.booklet').closest('div');
    if (container) {
      const btnNext = container.querySelector('#btnnext');
      const btnPrev = container.querySelector('#btnprev');
      const btnHome = container.querySelector('#btnhome');

      if (btnNext) {

        const button = document.createElement('input');
        button.type = 'button';
        button.value = '  →  ';
        button.style.display = 'inline';
        button.onclick = () => showBookletPage(-2);

        btnNext.innerHTML = '';
        btnNext.appendChild(button);
      }
      if (btnPrev) {
        const button = document.createElement('input');
        button.type = 'button';
        button.value = '  ←  ';
        button.style.display = 'inline';
        button.onclick = () => showBookletPage(-1);

        btnPrev.innerHTML = '';
        btnPrev.appendChild(button);
      }
      if (btnHome) {
        const button = document.createElement('input');
        button.type = 'button';
        button.value = 'Cover';
        button.style.display = 'inline';
        button.onclick = () => showBookletPage(0);

        btnHome.innerHTML = '';
        btnHome.appendChild(button);
      }
    }
  };

  const resetBookletStateValues=()=>{
    setBookletContainer(null);
    setBookletNumPages(0);
    setBookletCurrentPage(0);
    bookletCurrentPageRef.current = 0;
    bookletNumPagesRef.current = 0;
    bookletContainerRef.current = null;
    setBookletStartClicked(false);
    setDocumentHtml('');
    setBookletCoverUrl('');
    setIsBooklet(false);
  };

  useEffect(() => {
    bookletCurrentPageRef.current = bookletCurrentPage;
  }, [bookletCurrentPage]);

  useEffect(() => {
    bookletNumPagesRef.current = bookletNumPages;
  }, [bookletNumPages]);

  useEffect(() => {
    bookletContainerRef.current = bookletContainer;
  }, [bookletContainer]);

  return (
    <>
      {props.isLoading ?
        <SkeletonGrid
          rowCount={6}
          colCount={1}
          className='p-3 mb-2 mt-4'
        />
        :
        <>
          <div
            id="content"
            className={`overflow-auto questions-details ${props.isFromQset ? '':'ps-5'} w-100`}>
            {props.type != QuestionPreviewTypes.questionPreview && <div className='d-flex flex-row gap-2 align-items-center'>
              {!props.isFromQset &&
              <h4>Question {props.selectedQuestionId + 1}</h4>
              }
              <div>{props.questionDetails?.question?.resources.filter((resource) =>
                resource.endsWith('.htm')
              ).length > 0 && (
                <>
                  <div
                    className={`${props.isFromQset && 'mb-4'} d-flex reading-block-header`}
                    onClick={() => setReadingPassage(!readingPassage)}>
                    <FontAwesomeIcon className="mx-2" color="#F7931E" icon={faBookOpen} />
                    <div style={{ color: '#F7931E' }}>View Question File/Passage</div>
                  </div>
                </>
              )}
              </div>
            </div>}
            {readingPassage && (<>
              <div>
                <div className="d-flex pb-4" style={{ flexDirection: 'column' }}>
                  {isPassageLoading ?
                    <>
                      {[...Array(3)].map((_, index) => (
                        <Skeleton key={index} />
                      ))}
                    </>
                    :
                    <>
                      {htmlContent?.map((content, index) => (
                        <>
                          <div style={{borderBottom: '2px solid #e7e5e5', marginBottom: '1em'}}
                            key={index}
                            id={'htmlRes' + index}
                            dangerouslySetInnerHTML={{ __html: content }}></div>
                          <br></br>
                        </>
                      ))}
                    </>
                  }
                </div>
              </div>
              {isBooklet && <div>
                <div className={`box-background border-2 border-bottom mb-4 ${!bookletStartClicked ? '' : 'd-none'}`}>
                  <div className='text-center'> <img src={bookletCoverUrl}></img> </div>
                  <div className='text-center'>  <button onClick={() => { showBookletPage(1); }}>Start</button></div>
                </div>
                <div className={`box-background border-top mb-5 ${bookletStartClicked ?'':'d-none'}`} dangerouslySetInnerHTML={{ __html: documentHtml }}></div>
              </div>}
            </>)}

            {props.questionDetails?.blockedText ? (
              <p
                dangerouslySetInnerHTML={{ __html: props.questionDetails?.blockedText }}
                className="fw-bold text-danger"></p>
            ) : (
              <>
                {props.selectedLanguage === 1 && (props.questionDetails?.question?.question === '' || props.questionDetails?.question?.question === null) ? (
                  <p className="fw-bold text-danger">
                Spanish version of the selected question is not available
                  </p>
                ) : (
                  <p className='questionWrapper' dangerouslySetInnerHTML={{__html: props.questionDetails?.question?.question}}></p>
                )}
              </>
            )}

            <div className="classroom-content pb-5">
              {type1 && (
                <>
                  <div
                    className={`classroom-content-box mb-4 pb-4 overflow-auto ${answerDetails && 'open'
                    } `}>
                    <div className="classroom-content-header d-flex justify-content-between align-items-center">
                      <span className="d-flex flex-row align-items-center">
                        <h4>Answer</h4>
                        {props.type == QuestionPreviewTypes.classRoomPreview &&
                    answerDetails &&
                    props.questionDetails?.question?.mcAnswer?.filter((a) => a.isCorrect == 1)
                      .length >= 1 && (
                          <span
                            className="showAnswerButton mx-3 px-2 py-1"
                            onClick={() => setShowAnswer(!showAnswer)}>
                            {showAnswer ? 'Hide Correct' : 'Show Correct'}
                          </span>
                        )}
                      </span>
                      <button
                        onClick={() => setAnswerDetails(!answerDetails)}
                        className="rounded-circle z-index10">
                        <FontAwesomeIcon icon={faChevronRight} />
                      </button>
                    </div>
                    <div className="overflow-auto">
                      {answerDetails &&
                  props.questionDetails?.question?.mcAnswer?.map((answer, index) => {
                    return (
                      <div key={index} className="form-check d-flex" ref={formCheckRef}>
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name="flexRadioDefault22"
                          id="Modes1c"
                          value={answer.isCorrect == 1 ? 'correct' : 'incorrect'}
                          checked={
                            props.type == QuestionPreviewTypes.classRoomPreview
                              ? showAnswer && answer.isCorrect == 1
                                ? true
                                : false
                              : answer.isCorrect == 1
                                ? true
                                : false
                          }
                        />
                        <label
                          className="form-check-label answer-label me-1"
                          dangerouslySetInnerHTML={{
                            __html: `${props.mcStyle === 0
                              ? `${index + 1}.${'  '}`
                              : props.mcStyle === 1
                                ? `${String.fromCharCode(97 + index).toUpperCase()}.${'  '}
                                     `
                                : `${String.fromCharCode(97 + index)}.${'  '}`
                            } ${removePTags(answer.answer)}`
                          }}></label>
                        <span style={{ color: 'green', marginTop: '3px' }}>
                          {props.type == QuestionPreviewTypes.classRoomPreview
                            ? showAnswer && answer.isCorrect == 1
                              ? ' (Correct)'
                              : ''
                            : answer.isCorrect == 1
                              ? ' (Correct)'
                              : ''}
                        </span>
                      </div>
                    );
                  })}
                    </div>
                  </div>
                  <div className={`classroom-content-box mb-4 pb-4 ${hintDetails && 'open'} `}>
                    <div className="classroom-content-header d-flex justify-content-between align-items-center">
                      <h4>Hint</h4>
                      <button
                        onClick={() => setHintDetails(!hintDetails)}
                        className="rounded-circle z-index10">
                        <FontAwesomeIcon icon={faChevronRight} />
                      </button>
                    </div>
                    <div className={`toggleDive ${!hintDetails && 'd-none'}`}>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: props.questionDetails?.question?.hint
                        }}></p>
                    </div>
                  </div>
                  <div className={`classroom-content-box mb-4 pb-4 ${reasonDetail && 'open'} `}>
                    <div className="classroom-content-header d-flex justify-content-between align-items-center">
                      <h4>Reason</h4>
                      <button
                        onClick={() => setReasonDetail(!reasonDetail)}
                        className="rounded-circle z-index10">
                        <FontAwesomeIcon icon={faChevronRight} />
                      </button>
                    </div>

                    <div className={`toggleDive ${!reasonDetail && 'd-none'}`}>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: props.questionDetails?.question?.reason
                        }}></p>
                    </div>
                  </div>
                </>
              )}
              {type2 && (
                <>
                  <div className={`classroom-content-box mb-4 pb-4 ${sampleAnswerDetails && 'open'} `}>
                    <div className="classroom-content-header d-flex justify-content-between align-items-center">
                      <h4>Sample Answer</h4>
                      <button
                        onClick={() => setSampleAnswerDetails(!sampleAnswerDetails)}
                        className="rounded-circle  z-index10">
                        <FontAwesomeIcon icon={faChevronRight} />
                      </button>
                    </div>
                    <div className={`toggleDive ${!sampleAnswerDetails && 'd-none'}`}>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: props.questionDetails?.question?.sampleAnswer
                        }}></p>
                    </div>
                  </div>
                  <div className={`classroom-content-box mb-4 pb-4 ${optionDetails && 'open'} `}>
                    <div className="classroom-content-header d-flex justify-content-between align-items-center">
                      <h4>Options</h4>
                      <button
                        onClick={() => {setOptionDetails(!optionDetails) , (!optionDetails && updatedMaxPoint == null)?setUpdatedMaxPoint(props.questionDetails?.question?.options?.maxPoint):null;}}
                        className="rounded-circle z-index10">
                        <FontAwesomeIcon icon={faChevronRight} />
                      </button>
                    </div>
                    <div className={`toggleDive ${!optionDetails && 'd-none'}`}>
                      <Row className='mb-2'>
                        <Col>Number Of Lines for the answer: {props.questionDetails?.question?.options?.answerSize}</Col>
                      </Row>
               
                      { (props.type != QuestionPreviewTypes.editAssignmentPreview || !props.questionDetails?.question?.options?.isEditable) &&
                   <Row><Col>{props.questionDetails?.question?.options?.isDefaultMaxPoint && props.questionDetails?.question?.options?.isEditable
                     ?  'Default Maximum Points (can be changed under Edit Assignment Options):': 'Maximum Points:'} &nbsp;{props.questionDetails?.question?.options?.maxPoint}
                   </Col>
                   </Row>
                      }

                      {(props.type == QuestionPreviewTypes.editAssignmentPreview && props.questionDetails?.question?.options?.isEditable) && 
                     <><Row><Col className='d-flex gap-3 col-4'><div className='align-items-center d-flex col-7'><span>Maximum Points &nbsp;</span>
                       <span><OverlayTrigger
                         placement="top"
                         overlay={
                           <Tooltip className="initial-assignment-tooltip">
                            To change the maximum point value for this question, enter a new value between 1 to 100 in the input box
                           </Tooltip>
                         }>
                         <FontAwesomeIcon className='circle-question' icon={faQuestionCircle} />
                       </OverlayTrigger>
                       </span>
                     </div>
                     <div className='col-5'><input
                       type='number'
                       className='form-control'
                       min="1"
                       max="100"
                       value={updatedMaxPoint}
                       onChange={handleUpdateMaxPointChange}
                       onBlur={handleUpdateMaxPointBlur}
                       onInput={() => setUpdatedMaxPointError('')}
                       onKeyDown={(e) => {
                         if (e.key === '+' || e.key === '-' || e.key === '.') {
                           e.preventDefault();
                         }
                       }}
                     /></div>
                     </Col>
                     </Row>
                     <Row><Col className='col-4 d-flex justify-content-end'>
                       {maxPointUpdateMessage.length>0 && <span className='success-text fs-6'>{maxPointUpdateMessage}.</span>}
                     </Col></Row>
                     <Row><Col className='col-5 d-flex'>
                       {updatedMaxPointError.length>0 && <span className='text-danger fs-6'>{updatedMaxPointError}.</span>}
                     </Col></Row>
                     </>
                      }
                      <Row className=' mt-2'>
                        <Col>Type: <span dangerouslySetInnerHTML={{
                          __html: props.questionDetails?.question?.options?.type
                        }}></span></Col>
                      </Row>
                    </div>
                  </div>
                </>
              )}
              {(type1 || type2) && (
                <>
                  {!props.isPublicAssignment && 
              <AttachResources
                questionDetails={props.questionDetails}
                nextQuestionHandler={props.nextQuestionHandler}
                assignedStatus={props.assignedStatus}
                assignmentId={props.assignmentId}
                questionCount={props.questionCount}
                previewType={props.type}
                assignmentName={props.assignmentName}
                setAssignmentDetails={props.setAssignmentDetails}
                assignmentDetails={props.assignmentDetails}
              />
                  }
                  <div className={`classroom-content-box mb-4 pb-4 ${tagAttributeStandard && 'open'} `}>
                    <div className="classroom-content-header d-flex justify-content-between align-items-center">
                      <h4>Topic / Tag / Attribute / Standard</h4>
                      <button
                        onClick={() => setTagAttributeStandard(!tagAttributeStandard)}
                        className="rounded-circle z-index10">
                        <FontAwesomeIcon icon={faChevronRight} />
                      </button>
                    </div>
                    <div className={`toggleDive ${!tagAttributeStandard && 'd-none'}`}>
                      <h3 style={{ marginTop: '5px' }}></h3>
                      <div className="custom-table table-responsive currentlist-table not-assigned-table tags-table">
                        <table className="table currentlist-table">
                          <thead>
                            <tr>
                              <th>Topics</th>
                              <th>Tags</th>
                              <th>Attributes</th>
                              <th>Standards</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <ul>
                                  {props.questionDetails?.topics?.map((item, index) => (
                                    <li key={index}>{item}</li>
                                  ))}
                                </ul>
                              </td>
                              <td>
                                <ul>
                                  {props.questionDetails?.tags?.map((item, index) => (
                                    <li key={index}>{item}</li>
                                  ))}
                                </ul>
                              </td>
                              <td>
                                <ul>
                                  {props.questionDetails?.attributes?.map((item, index) => (
                                    <li key={index}>{item}</li>
                                  ))}
                                </ul>
                              </td>
                              <td>
                                <ul>
                                  {props.questionDetails?.standards?.map((item, index) => (
                                    <li key={index}>{item}</li>
                                  ))}
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            {props.type == QuestionPreviewTypes.questionPreview && !props.isFromQset &&
        !props.isLoading &&
        !props.questionDetails?.blockedText && (
              <div className="d-flex justify-content-end me-2">
                <button
                  id="printButton"
                  className={`btn btn-castleRed mt-5 ms-3 btn-back ${isPdfGenerating ? 'disabled' : ''
                  }`}
                  onClick={handlePrint}>
                  {isPdfGenerating ? 'Generating PDF...' : 'Print to PDF'}
                </button>
              </div>
            )}
            {props.type == QuestionPreviewTypes.assignmentPreview &&
        !props.isLoading && (
              <div className="d-flex justify-content-end me-2 pb-5">
                <button
                  onClick={props.nextQuestionHandler}
                  className={`btn btn-castleWhite mt-5 ${props.lastQuestion ? 'disabled' : ''}`}>
              Next Question
                </button>
              </div>
            )}
          </div>
        </>
      }
    </>
  );
};

QuestionDetail.propTypes = {
  questionDetails: PropTypes.object,
  nextQuestionHandler: PropTypes.func,
  selectedQuestionId: PropTypes.number,
  lastQuestion: PropTypes.bool,
  isLoading: PropTypes.bool,
  mcStyle: PropTypes.number,
  assignedStatus: PropTypes.number,
  assignmentId: PropTypes.number,
  questionCount: PropTypes.number,
  type: PropTypes.string,
  selectedLanguage: PropTypes.number,
  assignmentName: PropTypes.string,
  setAssignmentDetails: PropTypes.func,
  assignmentDetails: PropTypes.object,
  isPublicAssignment: PropTypes.bool,
  isFromQset: PropTypes.bool
};

export default QuestionDetail;
